import React from 'react';
import type { AssignmentRow } from '../useAssignmentRows';

const SHOWN = 3;

// More classes than linked courses is the shape of a class the assignment cannot reach.
const ClassesCell = ({ row }: { row: AssignmentRow }) => {
  const { class_names: names, classes, courses } = row;
  const short = courses > 0 && classes > courses;

  return (
    <div className="tw-text-sm">
      {names.length === 0 && <span className="tw-text-spa-tertiary">—</span>}
      {names.slice(0, SHOWN).map(name => (
        <div key={name} className="tw-max-w-[12rem] tw-truncate" title={name}>{name}</div>
      ))}
      {names.length > SHOWN && (
        <div className="tw-text-sm tw-text-spa-tertiary" title={names.slice(SHOWN).join(', ')}>
          {`+${names.length - SHOWN} more`}
        </div>
      )}
      <div className={`tw-text-sm ${short ? 'tw-text-spa-error' : 'tw-text-spa-tertiary'}`}>
        {courses === 0 ? 'no LMS course' : `${courses} LMS ${courses === 1 ? 'course' : 'courses'}`}
      </div>
    </div>
  );
};

export default ClassesCell;
